export const stepMap = {
	// supplier ID
	3: {
		// step in the configuration flow
		0: 'Fahrzeugauswahl',
		1: 'Produktauswahl',
		2: 'Gültigkeitszeitraum',
		3: 'Kennzeicheneingabe',
	},
	14: {
		0: 'Fahrzeugauswahl',
		1: 'Produktauswahl',
		2: 'Gültigkeitszeitraum',
		3: 'Kennzeicheneingabe',
	},
	7: {
		0: 'Fahrzeugauswahl',
		1: 'Produktauswahl',
		2: 'Gültigkeitszeitraum',
		3: 'Kennzeicheneingabe',
	},
	6: {
		0: 'Produktauswahl',
		1: 'Gültigkeitszeitraum',
		2: 'Kennzeicheneingabe',
	},
};
